import styled from '@emotion/styled'
import { CardContent } from '@mui/material'

export const StyledCardContent = styled(CardContent)`
  padding: ${({ theme }) => theme.spacing(2)};
  flex-grow: 1;

  &:last-of-type {
    padding-bottom: 16px;
  }
`
